import { render, staticRenderFns } from "./launch.vue?vue&type=template&id=fef8c940&scoped=true&lang=pug"
import script from "./launch.vue?vue&type=script&lang=js"
export * from "./launch.vue?vue&type=script&lang=js"
import style0 from "./launch.vue?vue&type=style&index=0&id=fef8c940&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef8c940",
  null
  
)

export default component.exports